// extracted by mini-css-extract-plugin
module.exports = {"button":"theme_button_2pC6e","message":"theme_message_2AgSG","title":"theme_title_2-NFB"};